import { FeatureFlags } from '../constants/FeatureFlags';
import { usePublicFeatureFlags } from './usePublicFeatureFlags';
export function useIsRevenueHubEnabled() {
  const {
    featureFlags
  } = usePublicFeatureFlags();
  return featureFlags.includes(FeatureFlags.PUBLIC_REVENUE_HUB);
}